import * as fs from 'fs';
import * as path from 'path';
import type { MatrixVariantRow } from './survey-inventory-extract';
import { formatLayoutTasksMarkdown, LAYOUT_TASKS_FILENAME } from './survey-inventory-extract';

export function writeLayoutTasksFile(projectRoot: string, variants: MatrixVariantRow[]): string {
  const tasksPath = path.join(projectRoot, LAYOUT_TASKS_FILENAME);
  fs.writeFileSync(tasksPath, formatLayoutTasksMarkdown(variants), 'utf8');
  return tasksPath;
}
